import styled from 'styled-components';

export const InfoIcon = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.grey[700]};
`;
